/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_SubjectInputs */

const cs_gdpr_col_subject = /** @type {(inputs: Gdpr_Col_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koho`)
};

const en_gdpr_col_subject = /** @type {(inputs: Gdpr_Col_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Gdpr_Col_SubjectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_subject = /** @type {((inputs?: Gdpr_Col_SubjectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_SubjectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_subject(inputs)
	return cs_gdpr_col_subject(inputs)
});